import { styled } from '@mui/material';

import { ReactNode } from 'react';

import { NavLink } from 'react-router';

import { BackArrowIcon } from '@app-velocity/icons';

import { Box } from '@app-velocity/ui';

export type PageBackHeaderProps = {
  title: ReactNode;
  secondaryTitle?: ReactNode;
  to?: string;
};

const StyledBackArrowContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 'calc(var(--basic-grid) * 2)',
  color: 'var(--text-text-primary-color)',
  fontWeight: 'var(--font-weight-regular)',
  fontSize: 'var(--font-size-regular)',
  lineHeight: 'var(--line-height-medium)',
  padding: `${theme.spacing(4)} ${theme.spacing(2)}`,
  svg: {
    fill: 'var(--icon-icon-secondary-color)',
  },
}));

const HeaderText = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontSize: 12,
}));

const Title = styled('h1')({
  fontWeight: 600,
  color: 'var(--color-neutral-900)',
  fontSize: 12,
  margin: 0,
});

const Secondary = styled('span')({
  fontWeight: 500,
  color: 'var(--color-neutral-600)',
});

export const PageBackHeader = ({
  title,
  secondaryTitle,
  to,
}: PageBackHeaderProps) => {
  return (
    <StyledBackArrowContainer data-testid="modal-close-icon">
      {to ? (
        <NavLink to={to}>
          <BackArrowIcon />
        </NavLink>
      ) : undefined}
      <HeaderText>
        <Title>{title}</Title>
        {secondaryTitle ? <Secondary>{secondaryTitle}</Secondary> : undefined}
      </HeaderText>
    </StyledBackArrowContainer>
  );
};
